/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/credentialLists.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_ALL_EVENTS_LIST } from "../graphql";
import { VApplication } from "../../../application";

import { useEmailId } from "../../../pages/ProvisionalPage/provider";
import moment from "moment";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IPolicyListsMethods extends IPluginMethodMap {
  getPolicyListsProps(args: any): Promise<any>;
}

export interface IGetCredentialIssuedListProps {
  offset?: number;
  size?: number;
  where?: any;
}

export class PolicyListsService implements IAgentPlugin {
  readonly methods: IPolicyListsMethods;

  constructor() {
    this.methods = {
      getPolicyListsProps: this.getProps.bind(this),
    };
  }

  async getProps(args: IGetCredentialIssuedListProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const { email } = useEmailId();
    console.log(`args in service`, args);
    let _where1 = args?.where?.filter(
      (item) => item?.column === "policyNumber"
    );
    let _where2 = args?.where?.filter(
      (item) => item?.column !== "policyNumber"
    );
    try {
      if (client) {
        const res = await client.query({
          query: GET_ALL_EVENTS_LIST,
          variables: {
            input: {
              skip: args?.offset ?? 0,
              limit: args?.size ?? 10,
              where:[
                ..._where2
              ]
            },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          console.log(`event data`, res);
          let _rowData = this.formatTable(res?.data?.getListOfCyclone?.data);
          return {
            ...config,
            ultUsers: _rowData,
            isEmpty: res?.data?.getListOfCyclone?.data?.length <= 0,
            // studentGroup: holderGroups,
            activePage: res?.data?.getListOfCyclone?.currentPage,
            pageSize: res?.data?.getListOfCyclone?.pageSize,
            totalCount: res?.data?.getListOfCyclone?.totalCount,
            totalPages: res?.data?.getListOfCyclone?.totalPages,
          };
        }
      }
    } catch (err: any) {
      return {
        isEmpty: true,
      };
    }
  }

  private formatTable(tableData: any) {
    let _rowData =
      Array.isArray(tableData) &&
      tableData.map((item: any) => {
        return {
          rowData: item,
          id: item?.eventId,
          status:item?.status,
          name:item?.stormName,
          dateCreated: item?.date
          ? moment(item?.date).format("LLL")
          : "-",
          MaxWindSpeed:item?.vmax,
          MinWindSpeed:item?.vmin
        };
      });
    return _rowData;
  }
  // return { ...(config || {}) };
}

